<template>
    <Main :brand="brand" :user-agent="userAgent" v-if="(activeContent.length >= 0)"></Main>
    <Sub :active-content="activeContent" :brand="brand" v-else></Sub>
</template>

<script>
    import Main from './HeaderElement/Main'
    import Sub from './HeaderElement/Sub'

    export default {
        name: "Header",
        props: ['brand', 'userAgent', 'activeContent'],
        components: {
            Main, Sub
        },
        methods:{
            isInstalledByType:function(extension){
                return this.$parent.isInstalledByType(extension);
            },
            installExtension:function (extensionType) {
                this.$parent.installExtension(extensionType);
            }

        }
    }
</script>

<style>
    h2 {
        font-size: 30px;
        text-transform: uppercase;
        color: #fff;
        margin-bottom: 20px;
    }

    .title-tab-question-wrapper .extension-icon {
        width: 60px;
        --main-svg-color: #fff;
        --secondary-svg-color: #fff;
        margin-right: 20px;
    }

    .title-wrapper{
        border-top-left-radius: 10px;
    }

    .header {
        min-height: 132px;
        position: relative;
        padding: 16px 40px;
        background: #708090;
        background-size: cover;
        z-index: 2;
        border-top-right-radius: 10px;
    }

    .title-tab-question{
        padding: 18px;
    }

    /*
    *****************************
        question
    *****************************
    */

    .more-info-question-wrapper {
        position: relative;
        display: inline-block;
        vertical-align: top;
        float: right;
    }

    .question-char {
        border-radius: 50%;
        border: 3px solid #fff;
        width: 60px;
        height: 59px;
        line-height: 60px;
        background-color: #708090;
        font-weight: bold;
        font-size: 46px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        transition: all .3s;
        position: relative;
        z-index: 2;
    }

    .question-char:hover {
        background-color: #fff;
        color: #D3D3D3;
        border-color: #fff;
    }

    .question-char:hover + .question-tooltip {
        top: 75px;
        opacity: 1;
        z-index: 3;
        visibility: visible;
    }

    .details-content + .more-info-question-wrapper {
        top: 19px;
    }

    .question-tooltip {
        width: 340px;
        border-radius: 5px;
        background-color: #fff;
        position: absolute;
        box-shadow: 0 5px 10px rgba(0, 0, 0, .1);
        padding: 15px 20px;
        right: 0;
        color: #5D5D5D;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        z-index: -1;
        transition: all .5s;
        opacity: 0;
        top: 45px;
        visibility: hidden;
    }

    .question-tooltip:after {
        content: '';
        position: absolute;
        width: 15px;
        height: 15px;
        background-color: #fff;
        right: 24px;
        top: -5px;
        transform: rotate(45deg);
    }

    .main-tab-header-content {
        left: 0;
        top: 0;
        width: 100%;
    }

    .header.absolute{
        width: calc(100% - 285px);
        border-top-right-radius: 10px;
    }

    /*
   *****************************
       safely
   *****************************
   */

    .safely .header {
        background: url(../assets/brands/safely/img/header-bg.png) no-repeat center #0179b5;
        border-radius: 0 12px 0 0;
    }

    .safely .main-tab-header-content:after {
        background: url(../assets/brands/safely/img/header-bg.png) no-repeat center #0179b5;
        background-size: cover;
    }

    .safely .question-char {
        background-color: #1B89BF;
    }

    .safely .question-char:hover {
        background-color: #fff;
        color: #007BB6;
        border-color: #fff;
    }

    /*
   *****************************
       privately
   *****************************
   */

    .privately .header {
        background: url(../assets/brands/privately/img/tab-header-bg.jpg) no-repeat center #1fb58f;
    }

    .privately .main-tab-header-content:after {
        background: url(../assets/brands/privately/img/tab-header-bg.jpg) no-repeat center;
        background-size: cover;
    }

    .privately .question-char {
        border-radius: 50%;
        border: 5px solid #fff;
        width: 60px;
        height: 60px;
        line-height: 55px;
        background-color: transparent;
        font-weight: bold;
        font-size: 46px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        transition: all .3s;
        position: relative;
        z-index: 2;
    }

    .privately .question-char:hover {
        background-color: #fff;
        color: #20b28d;
        border-color: #fff;
    }


    .privately .header .img-wrapper {
        width: 120px;
        display: inline-block;
        vertical-align: top;
        text-align: center;
        position: relative;
        padding-top: 5px;
    }

    .privately .header .img-wrapper img {
        width: auto;
    }

    /*
   *****************************
       online-tools
   *****************************
   */

    .onlinetools .header {
        background: rgb(230,249,251);
        background: linear-gradient(90deg, rgba(230,249,251,1) 0%, rgba(245, 238, 221, 0.74) 20%);
        min-height: 137px;
    }

    .onlinetools .header.absolute {
        background-color: #E6D5AD;
        opacity: .99;
    }

    .onlinetools .question-char {
        background-color: #8BD8BD;
    }

    .onlinetools .question-char:hover {
        background-color: #fff;
        color: #8BD8BD;
        border-color: #fff;
    }

    .onlinetools .question-tooltip{
        color:#243665;
    }

    .onlinetools .title-tab-question-wrapper {
        margin-left: 35px;
    }

    .onlinetools h2 {
        color:#243665;
    }

    .onlinetools .title-tab-question p {
        color:#243665;
    }

    .onlinetools .header .details-wrapper h2 {
        color: #243665;
    }

    .onlinetools .extension-icon {
        color: #243665;
    }

</style>